/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ArbitratorEvaluationExportSourceSchema } from './arbitratorEvaluationExportSourceSchema';
import type { ArbitratorSessionExportSourceSchema } from './arbitratorSessionExportSourceSchema';
import type { PipelineExportSourceSchema } from './pipelineExportSourceSchema';
import type { SearchExportSourceSchema } from './searchExportSourceSchema';
import type { SearchInsightsExportSourceSchema } from './searchInsightsExportSourceSchema';
import type { StartExportRequestSchemaFormat } from './startExportRequestSchemaFormat';
import type { StartExportRequestSchemaHiddenInsightSectionsItem } from './startExportRequestSchemaHiddenInsightSectionsItem';
import type { StartExportRequestSchemaNameRedaction } from './startExportRequestSchemaNameRedaction';
import type { StartExportRequestSchemaTheme } from './startExportRequestSchemaTheme';

/**
 * Unified export creation request. Source is a discriminated union that
 * selects *where* the profiles come from; the rest of the fields describe
 * *how* they should be exported. New sources (e.g. "profiles" for a raw
 * list of profile IDs) only require adding a new source schema — no new
 * endpoint, no new audit action, no new frontend mutation.
 */
export interface StartExportRequestSchema {
  source: SearchExportSourceSchema | PipelineExportSourceSchema | ArbitratorSessionExportSourceSchema | ArbitratorEvaluationExportSourceSchema | SearchInsightsExportSourceSchema;
  format?: StartExportRequestSchemaFormat;
  include_contacts?: boolean;
  name_redaction?: StartExportRequestSchemaNameRedaction;
  hide_exporter?: boolean;
  verified_contacts_only?: boolean;
  personal_emails_only?: boolean;
  personal_emails_preferred?: boolean;
  include_highlights?: boolean;
  csv_columns?: ('full_name' | 'first_name' | 'last_name' | 'headline' | 'location' | 'linkedin_url' | 'current_title' | 'current_company' | 'summary' | 'skills' | 'education' | 'languages' | 'certifications')[] | null;
  theme?: StartExportRequestSchemaTheme;
  /** @maxItems 64 */
  hidden_insight_sections?: StartExportRequestSchemaHiddenInsightSectionsItem[];
  expected_credits?: number | null;
}
